import { NgModule } from '@angular/core';
import { PrizmDialogComponent } from './dialog.component';

/**
 * @deprecated
 * use standalone component instead
 * */
@NgModule({
  imports: [PrizmDialogComponent],
  declarations: [],
  exports: [PrizmDialogComponent],
})
export class PrizmDialogModule {}
